import React from "react";
import {
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  IconButton,
} from "@mui/material";

export default function BaseSubmitButton({
  text = "Save",
  color = "primary",
  variant = "contained",
  isSubmitting = false,
  onClick,
  validationSummary,
  endIcon,
  borderRadius,
  fullWidth = false,
  sx,
  startIcon,
  iconButton = false,
  ...rest
}) {
  const StartIcon = isSubmitting ? (
    <CircularProgress color={variant ? "primary" : "white"} size={18} />
  ) : (
    startIcon || null
  );
  const EndIcon = endIcon ? (
    <span className="material-icons">{endIcon}</span>
  ) : null;

  const errorMessage =
    validationSummary?.data?.messages[0] || validationSummary;

  if (iconButton) {
    return (
      <FormControl fullWidth={fullWidth}>
        <IconButton
          sx={{ ...sx }}
          variant={variant}
          color={color}
          disabled={isSubmitting}
          {...rest}
          onClick={onClick}>
          {StartIcon}
        </IconButton>
        {validationSummary && (
          <FormHelperText error>{errorMessage}</FormHelperText>
        )}
      </FormControl>
    );
  }

  return (
    <FormControl fullWidth={fullWidth}>
      <Button
        sx={{
          ...sx,
          textTransform: "none",
          fontWeight: "bold",
          borderRadius: borderRadius ? borderRadius : "5px !important",
        }}
        variant={variant}
        color={color}
        disabled={isSubmitting}
        startIcon={StartIcon}
        endIcon={EndIcon}
        {...rest}
        onClick={onClick}>
        {text}
      </Button>
      {validationSummary && (
        <FormHelperText error>{errorMessage}</FormHelperText>
      )}
    </FormControl>
  );
}
